<template>
  <div class="app flex-row align-items-center">
    <div class="container-fluid">
      <b-row class="justify-content-center login-box">
        <b-col md="6" lg="5" xl="4">
          <div class="text-center mb-15">
              <img class="mb-25 logo-login" :src="`/logo.svg`">
              <div class="font-400">Administration Dashboard Version 4.2.17</div>
          </div>
          <b-card-group>
            <b-card no-body class="p-20">
              <b-card-body>
                <form @submit.prevent="validateRegister">
                  <h4 class="font-400 text-center mb-30 color-primary">Log In</h4>
                  <div class="mb-15">
                    <b-form-input type="text" class="form-control" v-model="loginData.email" name="email" v-validate="'required|email'" placeholder="Email" autocomplete="on"/>
                    <span class="error">{{ errors.first('email') }}</span>
                  </div>
                  <div class="mb-20">
                    <b-form-input type="password" class="form-control" v-model="loginData.password"  name="password" v-validate="'required'" placeholder="Password" autocomplete="on"/>
                    <span class="error">{{ errors.first('password') }}</span>
                  </div>
                  <div class="mb-10">
                    <button type="submit" class="btn-primary w-100">Login</button>
                  </div>
                  <div class="text-center">
                    <a @click="openPage('/forgot_password')" class="color-primary custom-link font-13 font-400">Forget Password?</a>
                  </div>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Auth } from '@/api'

export default {
  name: 'Login',
  data: () => ({
    notificationSystem: {
      options: {
        success: {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        }
      }
    },
    loginData: {
      email: '',
      password: ''
    }
  }),
  created () {
    console.log('paradigm role', Auth.Session.get().paradigm_role)
    console.log('paradigm id', Auth.Session.get().paradigm_id)
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          if (this.loginData.password == 'Paradigm1234') {
            localStorage.setItem('is_default_pass', true)
          } else {
            localStorage.setItem('is_default_pass', false)
          }

          Auth.login(this.loginData).then(response => {
            Auth.Session.create(response)
            // console.log(response)
            // this.$router.push('/siteConfiguration')
            window.location.href = '/'
            console.log(response)
            this.$toast.success('you have successfully logged in!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cannot find data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    }
  }
}
</script>
